<div class="content-section">

  <div class="campaign-background pt-0">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
  </div>  

  <div class="title-div">
    <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
      <div class="col-11 p-0">

        <a class="back_bd" (click)=backToManageInstitution()>
          <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back |
          translate}}</a>
        <h2 class="background_title">
          {{ this.institutionId ? ('INSTITUTION_MANAGEMENT.EDIT_INSTITUTION_OR_GROUP' | translate) :
          ('INSTITUTION_MANAGEMENT.ADD_INSTITUTION_OR_GROUP' | translate) }}
        </h2>
      </div>
    </div>
  </div>

  <div class="container-fluid alone">
    <form class="form-container" name="addInstitutionForm" [formGroup]="addInstitutionForm" #ngForm="ngForm">
      <div class="my-4">
        <h3 class="section-title">{{ 'EVALUATION.INSTITUTION' | translate }}</h3>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group" *ngIf="addInstitutionForm.get('isGroup').value === false">
              <mat-form-field class="example-full-width">
                <mat-label>{{ translationKeys.ProfileDetails.InstitutionName | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="institutionName" maxlength="40"
                  [readonly]="userData && (userData.roleName.roleId == 3 || userData.roleName.roleId == 4)"
                  name="institutionName"
                  placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_INSTITUTION_NAME' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 40)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('institutionName').errors && (addInstitutionForm.get('institutionName').touched || addInstitutionForm.get('institutionName').dirty || submitted)}"
                  required>
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 40)</mat-hint>
              </mat-form-field>


            </div>
            <div class="form-group" *ngIf="addInstitutionForm.get('isGroup').value === true">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.GROUP_NAME' | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="institutionName" maxlength="40"
                  [readonly]="userData && (userData.roleName.roleId == 3 || userData.roleName.roleId == 4)"
                  name="institutionName"
                  placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_GROUP' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 40)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('institutionName').errors && (addInstitutionForm.get('institutionName').touched || addInstitutionForm.get('institutionName').dirty || submitted)}"
                  required>
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 40)</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="d-flex">
              <div class="col-auto">
                <div class="form-group">
                  <label>{{ 'INSTITUTION_MANAGEMENT.IS_GROUP' | translate }}</label><span class="mandatory">*</span>
                  <label class="switch mb-4 mt-2 d-block">
                    <input id="institution-group-slider" type="checkbox" name="isGroup" formControlName="isGroup"
                      (ngModelChange)="onValidation($event)">
                    <span class="slider round"></span>
                    <span class="status active">{{ 'INSTITUTION_MANAGEMENT.YES' | translate
                      }}</span>
                    <span class="status inactive">{{ 'INSTITUTION_MANAGEMENT.NO' | translate
                      }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12" *ngIf="!hideInstitutionType">
            <div class="form-group">              
              <div class="dropdown dropdown-bhp"
                [ngClass]="{'dropdown-invalid': !isInstitutionTypeValid()}" style="width: 100% !important;">
                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                  <input class="dropdown-toggle" type="text" readonly />
                  <span class="label-dropdown">{{ 'INSTITUTION_MANAGEMENT.TYPE' | translate }} <span
                      class="mandatory f10">*</span></span>
                  <span class="label-dropdown-value">{{ selectedInstitutionType | translate }}</span>
                  <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                </div>
                <ul class="dropdown-menu">
                  <li class="dropdown-item" *ngFor="let type of institutionTypes"
                    (click)="onChangeInstitutionType(type)">
                    {{type.typeName | translate | labelSanitizer}}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12"
            *ngIf="(userData) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.PRICING_COMMENT' | translate }}
                </mat-label>
                <input matInput inputSanitizer type="text" formControlName="pricingComment" maxlength="100"
                  name="pricingComment"
                  placeholder="{{ 'INSTITUTION_MANAGEMENT.PRICING_COMMENT' | translate }} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('pricingComment').errors && (addInstitutionForm.get('pricingComment').touched || addInstitutionForm.get('pricingComment').dirty)}">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-md-4 col-sm-12" *ngIf="(userData) && addInstitutionForm.get('isGroup').value === false && userData.roleName.roleId == 1">
            <div class="form-group">
              <div class="dropdown dropdown-bhp"
                  style="width: 100% !important;">
                  <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                    <input class="dropdown-toggle" type="text" readonly />
                    <span class="label-dropdown">{{ 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.FLOOR_PERMISSION' | translate}}</span>
                    <span class="label-dropdown-value">{{ selectedFloorPricePermission | translate }}</span>
                    <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                  </div>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item" *ngFor="let floorPricePermissionValue of floorPricePermissionValues"
                      (click)="onChangeFloorPricePermission(floorPricePermissionValue)">
                      {{floorPricePermissionValue.floorPriceValue | translate | labelSanitizer}}
                    </li>
                  </ul>
                </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12" *ngIf="(userData) && addInstitutionForm.get('isGroup').value === false && userData.roleName.roleId == 2 && mode != 'add'">
            <div class="form-group">
              <div class="dropdown dropdown-bhp floorPriceLabel">
                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                  <span class="label-dropdown">{{ 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.FLOOR_PERMISSION' | translate}}</span>
                  <span class="label-dropdown-value">{{ selectedFloorPricePermission | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        
          <div class="col-md-4 col-sm-12" *ngIf="(userData) && addInstitutionForm.get('isGroup').value === false && (userData.roleName.roleId == 1 || (userData.roleName.roleId == 2 && mode != 'add'))">
            <div class="form-group">
              <label for="endDate">{{ 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.VALID_UNTIL' | translate
                  }}</label>
              <mat-form-field appearance="fill" class="date-form-field floor-date-field"
                  [ngClass]="{'is-invalid': addInstitutionForm.get('floorPricePermissionValidUntil')?.errors}">
                  <input (click)="floorDatepicker.open()" matInput
                      [matDatepicker]="floorDatepicker"
                      [disabled]="addInstitutionForm.get('floorPricePermission').value !== 'YES' || userData.roleName.roleId > 1"
                      formControlName="floorPricePermissionValidUntil" readonly>
                  <mat-datepicker-toggle matSuffix
                      [for]="floorDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #floorDatepicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.SAP_CUSTOMER_NUMBER' | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="crmNumber" maxlength="30"
                  [readonly]="userData && (userData.roleName.roleId == 3 || userData.roleName.roleId == 4)"
                  name="crmNumber"
                  placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_SAP_CUSTOMER_NUMBER' | translate }} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 30)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('crmNumber').errors && (addInstitutionForm.get('crmNumber').touched || addInstitutionForm.get('crmNumber').dirty)}"
                  required>
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 30)</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="col-md-4 col-sm-12" *ngIf="addInstitutionForm.get('isGroup').value === false">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.BED_SIZE' | translate }}
                </mat-label>
                <input matInput inputSanitizer type="number" formControlName="bedSize" min="1" name="bedSize"
                  placeholder="{{ 'INSTITUTION_MANAGEMENT.BED_SIZE' | translate }}"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('bedSize').errors && (addInstitutionForm.get('bedSize').touched || addInstitutionForm.get('bedSize').dirty || submitted)}"
                  required>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.STREET' | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="addressLine1" maxlength="100"
                  name="addressLine1"
                  placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_STREET' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('addressLine1').errors && (addInstitutionForm.get('addressLine1').touched || addInstitutionForm.get('addressLine1').dirty)}">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.BUILDING_OR_SUITE_OR_OTHER' | translate
                  }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="addressLine2" maxlength="100"
                  [readonly]="userData && (userData.roleName.roleId == 3 || userData.roleName.roleId == 4)"
                  name="addressLine2"
                  placeholder="{{'INSTITUTION_MANAGEMENT.BUILDING_OR_SUITE_OR_OTHER' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('addressLine2').errors && (addInstitutionForm.get('addressLine2').touched || addInstitutionForm.get('addressLine2').dirty)}">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group" *ngIf="this.userData.roleName.roleId == 2">
              <div class="dropdown dropdown-bhp countryLabel">
                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                  <span class="label-dropdown">{{ 'AUTHORIZATION.COUNTRY' | translate }}</span>
                  <span class="label-dropdown-value">{{ selectedCountryName | translate }}</span>
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="this.userData.roleName.roleId != 2">
              <div class="dropdown dropdown-bhp" [ngClass]="{'dropdown-invalid': !isCountryValid()}"
                style="width: 100% !important;">
                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                  <input class="dropdown-toggle" type="text" readonly />
                  <span class="label-dropdown">{{ 'AUTHORIZATION.COUNTRY' | translate }} <span
                      class="mandatory f10">*</span></span>
                  <span class="label-dropdown-value">{{ selectedCountryName | translate }}</span>
                  <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                </div>
                <ul class="dropdown-menu">
                  <li class="dropdown-item" *ngFor="let country of countryList" (click)="onChangeCountry(country)" >
                    {{country.countryName | translate | labelSanitizer}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group" *ngIf="stateList && stateList.length > 0">
              <div class="dropdown dropdown-bhp" style="width: 100% !important;">
                <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                  <input class="dropdown-toggle" type="text" readonly />
                  <span class="label-dropdown">{{ 'AUTHORIZATION.STATE' | translate }}</span>
                  <span class="label-dropdown-value">{{ selectedStateName | translate }}</span>
                  <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                </div>
                <ul class="dropdown-menu">
                  <li class="dropdown-item" *ngFor="let state of stateList" (click)="onChangeState(state)">
                    {{state.stateName | translate | labelSanitizer}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'AUTHORIZATION.CITY' | translate }}</mat-label>
                <input *ngIf="!addInstitutionForm.get('isGroup').value" matInput inputSanitizer type="text"
                  formControlName="city" maxlength="25" min="1" name="city"
                  placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_CITY' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 25)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('city').errors && (addInstitutionForm.get('city').touched || addInstitutionForm.get('city').dirty )}"
                  required>
                <input *ngIf="addInstitutionForm.get('isGroup').value" matInput inputSanitizer type="text"
                  formControlName="city" maxlength="25" min="1" name="city"
                  placeholder="{{'INSTITUTION_MANAGEMENT.ENTER_CITY' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 25)"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('city').errors && (addInstitutionForm.get('city').touched || addInstitutionForm.get('city').dirty )}">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 25)</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'INSTITUTION_MANAGEMENT.POSTAL_CODE' | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="zipCode" maxlength="15" name="zipCode"
                  placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_POSTAL_CODE' | translate }}"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('zipCode').errors && (addInstitutionForm.get('zipCode').touched || addInstitutionForm.get('zipCode').dirty)}">
                <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 100)</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'AUTHORIZATION.PHONE' | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="phone" maxlength="20" min="1" name="phone"
                  placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_PHONE' | translate }}"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('phone').errors && (addInstitutionForm.get('phone').touched || addInstitutionForm.get('phone').dirty )}">
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{ 'AUTHORIZATION.FAX' | translate }}</mat-label>
                <input matInput inputSanitizer type="text" formControlName="fax" maxlength="20" name="fax"
                  placeholder="{{ 'INSTITUTION_MANAGEMENT.ENTER_FAX' | translate }}"
                  [ngClass]="{'is-invalid':addInstitutionForm.get('fax').errors && (addInstitutionForm.get('fax').touched || addInstitutionForm.get('fax').dirty )}">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="my-4"
        *ngIf="userData && !addInstitutionForm.get('isGroup').value && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">                
        <h3 class="section-title">{{ 'INSTITUTION_MANAGEMENT.CONTRACTS' | translate }}</h3>
      </div>
      <div class="my-4"
        *ngIf="userData && !addInstitutionForm.get('isGroup').value && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">   
        <div class="">
          <div class="col-md-4 col-sm-12 no-padding">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">

                  <!-- Usage Agreement Dropdown -->
                  <div class="dropdown dropdown-bhp"
                    style="width: 100% !important;">
                    <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                      <input class="dropdown-toggle" type="text" readonly />
                      <span class="label-dropdown">{{ 'INSTITUTION_MANAGEMENT.USAGE_AGREEMENT' | translate }}</span>
                      <span class="label-dropdown-value">{{ selectedUsageAgreement | translate }}</span>
                      <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                    </div>
                    <ul class="dropdown-menu">
                      <li class="dropdown-item" *ngFor="let usageAgreementValue of usageAgreementValues"
                        (click)="onChangeUsageAgreement(usageAgreementValue)">
                        {{ usageAgreementValue.usageValue | translate | labelSanitizer }}
                      </li>
                    </ul>
                  </div>

                  <!-- Data Processing Dropdown -->
                  <div class="dropdown dropdown-bhp"
                    style="width: 100% !important; margin-top: 1rem;">
                    <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                      <input class="dropdown-toggle" type="text" readonly />
                      <span class="label-dropdown">{{ 'INSTITUTION_MANAGEMENT.DATA_PROCESSING' | translate }}</span>
                      <span class="label-dropdown-value">{{ selectedDataProcessing | translate }}</span>
                      <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                    </div>
                    <ul class="dropdown-menu">
                      <li class="dropdown-item" *ngFor="let dataProcessingValue of dataProcessingValues"
                        (click)="onChangeDataProcessing(dataProcessingValue)">
                        {{ dataProcessingValue.processingValue | translate | labelSanitizer }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-4"
        *ngIf="(userData) && (addInstitutionForm.get('isGroup').value === false) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">
        <h3 class="section-title">{{ 'CONFIGURE.CONFIGURE' | translate }}</h3>
      </div>
      <div class="my-4"
        *ngIf="(userData) && (addInstitutionForm.get('isGroup').value === false) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="inputProdcutPackage">{{ 'LAYOUT_MODULE.EVALUATION' | translate }}</label>
              <div class="mb-2">
                <input type="checkbox" class="custom-control-input" id="isObserveSOPBenchmark"
                  formControlName="isObserveSOPBenchmark">
                <label for="isObserveSOPBenchmark">{{
                  'INSTITUTION_MANAGEMENT.OBSERVE_BENCHMARK_PART' | translate }}</label>
              </div>
              <div class="mb-2">
                <input type="checkbox" class="custom-control-input" id="shareDataWithHartmann"
                  formControlName="shareDataWithHartmann">
                <label for="shareDataWithHartmann">{{
                  'INSTITUTION_MANAGEMENT.SHARE_DATA_WITH_HARTMANN' | translate }}</label> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4"
        *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">
        <div class="">
          <div class="col-md-4 col-sm-12 no-padding">
            <h3 class="section-title"
              *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)">
              {{ 'USER_MANAGEMENT.LICENSES' | translate }}</h3>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group separate-section">
                  <label for="packageID" [ngClass]="{'text-invalid': !isPackageSelectionValid}">{{
                    'AUTHORIZATION.PRODUCT_PACKAGE' | translate
                    }}</label><span class="mandatory">*</span>
                  <div class="checkbox-wrapper" [ngClass]="{'checkbox-invalid': !isPackageSelectionValid}">
                    <div class="checkbox-container-list">
                      <div id="package-{{package.packageID}}" class="mb-2" *ngFor="let package of productPackage">
                        <input type="checkbox" class="custom-control-input" [checked]="package.isChecked"
                          (change)="onCheckPackage($event)" id="{{ package.packageID }}">
                        <label for="{{ package.packageID }}" [ngClass]="{'text-invalid': !isPackageSelectionValid}">
                          {{ package.packageName }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group" *ngIf="addInstitutionForm.get('isGroup').value === false">

                  <div class="form-group">
                    <div class="dropdown dropdown-bhp"
                      [ngClass]="{'is-invalid': addInstitutionForm.get('countryID').touched && addInstitutionForm.get('countryID').invalid}"
                      style="width: 100% !important;">
                      <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                        <input class="dropdown-toggle" type="text" readonly />
                        <span class="label-dropdown">{{ translationKeys.Authorization.UserAccountAmount | translate
                          }}<span class="mandatory f10">*</span></span>
                        <span class="label-dropdown-value">{{ selectedAmountLicences | translate }}</span>
                        <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                      </div>
                      <ul class="dropdown-menu">
                        <li class="dropdown-item" *ngFor="let licenseValue of licenseList"
                          (click)="onChangeLicenses(licenseValue)">
                          {{licenseValue}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-4 pl-3">
                <h3 class="section-title" *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)
                 && (addInstitutionForm.get('countryID').value == 3 ||
                 addInstitutionForm.get('countryID').value == 219 ||
                 addInstitutionForm.get('countryID').value == 15 )">{{'webKess' | translate}}</h3>
              </div>
              <div
                *ngIf="userData && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2) &&  webKessStatus?.toLowerCase() == 'pending'"
                class="webkess-container col-sm-12 col-md-12">
                <div class=" webkess-request col-sm-12 col-md-12 alert alert-warning" role="alert">
                  {{'USER_MANAGEMENT.IA_REQUESTED' | translate}} <br>
                  <ul class="webkess-list">
                    <li *ngIf="!institution.institution.activateWebKess && additionalChanges?.ActivateWebKess">
                      {{'USER_MANAGEMENT.ENABLE.WEBKESS' | translate}} </li>
                    <li *ngIf="!institution.institution.activateObservation && additionalChanges?.ActivateObservation">
                      {{'USER_MANAGEMENT.ENABLE.OBSERVATION' | translate}} </li>
                    <li *ngIf="!institution.institution.activateConsumption && additionalChanges?.ActivateConsumption">
                      {{'USER_MANAGEMENT.ENABLE.CONSUMPTION' | translate}} </li>
                    <li *ngIf="additionalChanges?.ActivateObservation == false">
                      {{'USER_MANAGEMENT.DISABLE.OBSERVATION' | translate}} </li>
                    <li *ngIf="additionalChanges?.ActivateConsumption == false">
                      {{'USER_MANAGEMENT.DISABLE.CONSUMPTION' | translate}} </li>
                  </ul>
                  <div>
                    <button (click)="denyReqModal()" class="btn-cancel-bd mr-4">{{'USER_MANAGEMENT.DENY_REQUEST'
                      |translate}}</button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)
            && (addInstitutionForm.get('countryID').value == 3 ||
            addInstitutionForm.get('countryID').value == 219 ||
            addInstitutionForm.get('countryID').value == 15 )">
                <div class="form-group">
                  <label for="activateWebKess">{{'USER_MANAGEMENT.ENABLE.WEBKESS' |
                    translate}}</label>
                  <label class="switch mb-4 mt-2 d-block">
                    <input type="checkbox" name="activateWebKess" formControlName="activateWebKess"
                      (change)="onChangeWebKess($event)">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)
            && (addInstitutionForm.get('countryID').value == 3 ||
            addInstitutionForm.get('countryID').value == 219 ||
            addInstitutionForm.get('countryID').value == 15 ) &&
            addInstitutionForm.get('activateWebKess').value == true">
                <div class="form-group">
                  <label for="activateConsumption">{{'USER_MANAGEMENT.ENABLE.CONSUMPTION' |
                    translate}}</label><span *ngIf="isSOPChecked()" class="mandatory">*</span>
                  <label class="switch mb-4 mt-2 d-block">
                    <input type="checkbox" name="activateConsumption" formControlName="activateConsumption"
                      (change)="onChangeConsumption($event)">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-6" *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)
            && (addInstitutionForm.get('countryID').value == 3 ||
            addInstitutionForm.get('countryID').value == 219 ||
            addInstitutionForm.get('countryID').value == 15 ) &&
            (isObserveChecked()) &&
            addInstitutionForm.get('activateWebKess').value == true">
                <div class="form-group">
                  <label for="activateObservation">{{'USER_MANAGEMENT.ENABLE.OBSERVATION' |
                    translate}}</label>
                  <label class="switch mb-4 mt-2 d-block">
                    <input type="checkbox" name="activateObservation" formControlName="activateObservation">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="(userData) && (!isgroup) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)
            && (addInstitutionForm.get('countryID').value == 3 ||
            addInstitutionForm.get('countryID').value == 219 ||
            addInstitutionForm.get('countryID').value == 15 ) &&
            addInstitutionForm.get('activateWebKess').value == true &&
            addInstitutionForm.get('activateConsumption').value == true">

                <div *ngIf="false" class="mb-2">
                  <input type="checkbox" class="custom-control-input" id="activateAutomaticConsumption"
                    formControlName="activateAutomaticConsumption">
                  <label for="activateAutomaticConsumption">{{'USER_MANAGEMENT.AUTOMATIC' |
                    translate}}</label>
                </div>

              </div>

            </div>
          </div>
          <div *ngIf="this.userData.roleName.roleId != 1" class="col-md-4 col-sm-12">
            <h3 class="section-title">{{ 'EVALUATION.SOP' | translate }}</h3>
            <app-sop-selection-by-type [saSOPS]="saSOPS" [caSOPS]="caSOPS" [institution]="institution"
              (sopChecked)="sopCheck($event)"></app-sop-selection-by-type>
          </div>
        </div>
      </div>
      <div class="my-4 d-flex justify-content-end">
        <button (click)='cancelModal()' class="btn-cancel-bd separate-buttons">{{
          translationKeys.Authorization.Cancel |
          translate }}</button>
        <button (click)='submitInsitution(template)'
          [ngClass]="(saveInsitutionFlag)?'btn-cancel-bd':'btn-continue-bordered-bd align-button'" class="ms-4">{{
          translationKeys.Authorization.Save | translate }}</button>
      </div>
    </form>
  </div>
</div>

<div class="side-appbar">
  <div class="container-fluid">
  </div>
</div>


<!-- Modal - Add User Confirmation -->
<ng-template #template>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="closeModal();modalRef.hide();"><img
        src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body">
    <p class="lead" *ngIf="!isgroup">
      {{ 'INSTITUTION_MANAGEMENT.YOU_HAVE_SUCCESSFULLY_ADDED_AN_INSTITUTION' | translate }}</p>
    <p class="lead" *ngIf="isgroup">{{ 'INSTITUTION_MANAGEMENT.GROUP_SUCCESSFULLY_ADDED' | translate }}
    </p>
    <br>
    <p class="lead" *ngIf="!isgroup">{{ 'INSTITUTION_MANAGEMENT.QUESTION_ADD_ADMIN_TO_INSTITUTION' | translate }}
    </p>
    <p class="lead" *ngIf="isgroup">{{ 'INSTITUTION_MANAGEMENT.QUESTION_ADD_ADMIN_TO_GROUP' | translate }}</p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button class="btn btn-continue-bordered-bd" data-dismiss="modal" (click)="modalRef.hide();adduser()">
        {{ 'USER_MANAGEMENT.ADD_USER' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #cancelmodal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    {{'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate}}
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'LAYOUT_MODULE.STAY' | translate }}</button>
      <button (click)="closeInsitution();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.LEAVE' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #denyModal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    {{'USER_MANAGEMENT.ASK_DENY_REQUEST' | translate}}
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
      <button (click)="denyReq();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DENY' | translate }}</button>
    </div>
  </div>
</ng-template>
